import { render, staticRenderFns } from "./BookSlider.vue?vue&type=template&id=1efc5268&scoped=true&"
import script from "./BookSlider.vue?vue&type=script&lang=js&"
export * from "./BookSlider.vue?vue&type=script&lang=js&"
import style0 from "./BookSlider.vue?vue&type=style&index=0&id=1efc5268&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efc5268",
  null
  
)

export default component.exports